import mergeConfig from 'coact/config/mergeConfig'
import consumersSchema from './consumers/schema.js'

const config = {
  models: {
    consumers: {
      schema: consumersSchema,
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
